import advantageController from '../../../controllers/advantageController/controller';
import Swal from 'sweetalert2';
import { EventBus } from '@/eventBus';
export default{
    name: 'SimpleTable',
    data(){
        return{
            company: '',
            advantageList: [],
            currentPage: 1,
            pageSize: 10,
            totalAdvantages: 0,
            totalPages: 0,
            searchQuery: '',
            allIcons: [],
            dropdownOpen: false,
            icons: [],
            sizes: [1, 5, 10, 20],
            advantage: {
                id: '',
                name : '',
                deskripsi : '',
                icon: '',
                language: '',
                status: '',
                created_by: '',
                created_by_name: '',
                created_on: '',
            },
            selectedAdvantage: {
                updated_by: '',
                updated_by_name: '',
            }
        }
    },
    computed:{
        filteredAdvantages() {
            return this.advantageList.filter((advantage) => {
                return advantage.name.toLowerCase().includes(this.searchQuery.toLowerCase());
            });
        },
        pages(){
            return Math.ceil(this.totalAdvantages / this.pageSize);
        },
        displayedPages() {
            const range = 1;
            let start = Math.max(this.currentPage - range, 1);
            let end = Math.min(this.currentPage + range, this.pages);
      
            // Jika kurang dari 3 halaman, sesuaikan
            if (end - start < 2) {
              if (start === 1) {
                end = Math.min(3, this.pages);
              } else if (end === this.pages) {
                start = Math.max(this.pages - 2, 1);
              }
            }
      
            const pages = [];
            for (let i = start; i <= end; i++) {
              pages.push(i);
            }
            return pages;
        },
        showStartEllipsis() {
            return this.displayedPages[0] > 1;
        },
        showEndEllipsis() {
            return this.displayedPages[this.displayedPages.length - 1] < this.pages;
        },
    },
    methods:{
        user(){
            const user = localStorage.getItem('user');
            const id = JSON.parse(user).mst_employee_id;
            this.advantage.created_by = id;
            this.selectedAdvantage.updated_by = id;
            const name = JSON.parse(user).mst_employee_name;
            this.advantage.created_by_name = name;
            this.selectedAdvantage.updated_by_name = name;
        },
        showModal(type, id) {
            this.user();
            const advantage = this.advantageList.find(advantage => advantage.id === id);
            if (advantage) {
                this.advantage = advantage;
                
                const modal = document.getElementById(type === 'edit' ? 'editAdvantage' : 'detailAdvantage');
                
                modal.style.display = 'block';
                requestAnimationFrame(() => {
                modal.classList.add('show');
                });
                
                document.body.classList.add('modal-open');
                
                const backdrop = document.createElement('div');
                backdrop.classList.add('modal-backdrop', 'fade');
                document.body.appendChild(backdrop);
                
                requestAnimationFrame(() => {
                backdrop.classList.add('show');
                });
            }
        },
        closeModal() {
          const modalIds = ['tambahAdvantage', 'editAdvantage', 'detailAdvantage'];
          modalIds.forEach(id => {
            const modal = document.getElementById(id);
            if (modal && modal.classList.contains('show')) {
              modal.classList.remove('show');
              setTimeout(() => {
                modal.style.display = 'none';
              }, 300);
            }
          });
        
          // Hapus backdrop
          const backdrops = document.querySelectorAll('.modal-backdrop');
          backdrops.forEach(backdrop => {
            backdrop.classList.remove('show');
            setTimeout(() => {
              if (backdrop.parentNode) {
                backdrop.parentNode.removeChild(backdrop);
              }
            }, 300);
          });
        
          // Hapus kelas atau atribut yang mengunci scroll pada body
          const body = document.body;
          body.classList.remove('modal-open');
          body.style.overflow = ''; // Menghapus properti overflow jika ada
          this.fetchAdvantage();
          this.resetForm();
          this.user();
        },    
        resetForm() {
            this.advantage.name = '';
            this.advantage.deskripsi = '';
            this.advantage.language = '';
            this.advantage.icon = '';
            this.advantage.status = '';
            this.iconSearch = '';
            this.icon();
        },
        changePage(page) {
            if (page > 0 && page <= this.pages) {
                this.currentPage = page;
                this.fetchAdvantage();
            }
        },
        async fetchAdvantage() {
            try {
                const company = this.company;
                const query = this.searchQuery.trim() === '' ? null : this.searchQuery;
                const response = await advantageController.fetchAdvantage(query, this.currentPage, this.pageSize, company);
                this.advantageList = response.data;
                this.totalAllAdvantage();
            } catch (error) {
                console.error('Error fetching advantages:', error);
                throw error;
            }
        },
        async totalAllAdvantage() {
            try {
                const company = this.company;
                const response = await advantageController.totalAllAdvantage(company);
                this.totalAdvantages = response.data;
            } catch (error) {
                console.error('Error fetching advantages:', error);
                throw error;
            }
        },
        async addAdvantage() {
            try {
                const name = this.advantage.name;
                const deskripsi = this.advantage.deskripsi;
                const icon = this.advantage.icon;
                const language = this.advantage.language;
                const status = this.advantage.status;
                const company = this.company;
                const created_by = this.advantage.created_by;
                const created_by_name = this.advantage.created_by_name;
                if (!name || !deskripsi || !icon || !language || !status || !created_by || !created_by_name) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal menambahkan data',
                        text: 'Isi semua field!!',
                        timer: 1500
                    })
                }
                const now = new Date();
                const created_on = now.toISOString().slice(0, 19).replace('T', ' ');
                const add = {
                    name: name,
                    description: deskripsi,
                    icon: icon,
                    language : language,
                    is_active: status,
                    id_company: company,
                    created_by: created_by,
                    created_by_name: created_by_name,
                    created_on: created_on
                }
                await advantageController.addAdvantage(add);
                Swal.fire({
                    icon: 'success',
                    title: 'Advantage berhasil ditambahkan',
                    timer: 1500
                })
                this.closeModal();
                this.fetchAdvantage();
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Gagal menambahkan data',
                    text: error.message,
                    timer: 1500
                })
            }
        },
        async updateAdvantage() {
            try {
                const id = this.advantage.id;
                const name = this.advantage.name;
                const deskripsi = this.advantage.deskripsi;
                const icon = this.advantage.icon;
                const language = this.advantage.language;
                const status = this.advantage.status;
                const updated_by = this.selectedAdvantage.updated_by;
                const updated_by_name = this.selectedAdvantage.updated_by_name;
                if (!id || !name || !deskripsi || !icon || !language || !status || !updated_by || !updated_by_name) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal mengubah data',
                        text: 'Isi semua field!!',
                        timer: 1500
                    })
                    return;
                }
                const update = {
                    id: id,
                    name: name,
                    description: deskripsi,
                    icon: icon,
                    language: language,
                    is_active: status,
                    updated_by: updated_by,
                    updated_by_name: updated_by_name
                }
                const response = await advantageController.updateAdvantage(update);
                if (response.status === 200) {
                    Swal.fire({
                        icon: 'success',
                        title: 'Advantage berhasil diubah',
                        timer: 1500
                    })
                    this.closeModal();
                    this.fetchAdvantage();
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal mengubah data',
                        timer: 1500
                    })
                }
            } catch (error) {
                Swal.fire({
                    icon: 'error',
                    title: 'Gagal mengubah data',
                    text: error.message,
                    timer: 1500
                })
            }
        },
        async deleteAdvantage(id) {
            const confirmed = await Swal.fire({
                title: 'Are you sure?',
                text: 'You won\'t be able to revert this!',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#3085d6',
                cancelButtonColor: '#d33',
                confirmButtonText: 'Yes, delete it!'
            }).then((result) => {
                if (result.isConfirmed) {
                    return true;
                }
                return false;
            });
            if (confirmed) {
                try{
                    await advantageController.deleteAdvantage(id);
                    Swal.fire({
                        icon: 'success',
                        title: 'Advantage berhasil dihapus',
                        showConfirmButton: false,
                        timer: 1500
                    })
                    this.fetchAdvantage();
                } catch (error) {
                    Swal.fire({
                        icon: 'error',
                        title: 'Gagal menghapus data',
                        text: error.message,
                        timer: 1500
                    })
                }
            }
        },
        onCompanyChange(newCompany) {
            this.company = newCompany;
        },
        async icon(){
            const res = await fetch('https://raw.githubusercontent.com/twbs/icons/main/font/bootstrap-icons.json');
            const data = await res.json();
            this.allIcons = Object.keys(data).map(name => `bi bi-${name}`);
            this.icons = this.allIcons;
        },
        selectIcon(icon) {
            this.advantage.icon = icon;
            this.dropdownOpen = false;
        },
        searchIcon() {
            const keyword = this.iconSearch.toLowerCase();
            this.icons = this.allIcons.filter(icon =>
                icon.toLowerCase().includes(keyword)
            );
        }
    },
    mounted(){
        this.user();
        this.company = localStorage.getItem('company');
        EventBus.$on("companyChanged", this.onCompanyChange);
        this.icon();
        this.icons = this.allIcons; 
    },
    watch: {
        searchQuery: {
            handler: 'fetchAdvantage',
        },
        company: {
            handler: 'fetchAdvantage'
        }
    },
    created() {
        this.icons = this.allIcons; // Awal: tampilkan semua
    },
}